import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'loren-card',
    templateUrl: './loren-card.component.html',
    styleUrls: ['./loren-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenCardComponent {
    @Input() title: string;
    @Input() subTitle: string;
    @Input() translationOptions: object;
    @Input() imgSrc: string;
    @Input() look: string;
    @Input() iconName: string;
    @Input() iconColor = 'warn';

}
